// this file is automatically generated by sourcemaps.js script
export const versions = {commitHash: 'fc23dd20', branch: 'HEAD'};